import { css } from "@emotion/react";

type Styles = {
  mobile?: any;
  tablet?: any;
  desktop?: any;
};

// Avoid applying a `max-width` so that we can allow a cascading effect to
// happen, e.g. tablet styles will apply if desktop styles are not provided.
export const mediaQueries = {
  mobile: `@media (min-width: 0)`,
  tablet: `@media (min-width: 660px)`,
  desktop: `@media (min-width: 1024px)`,
};

export const getResponsiveStyles = (styles: Styles) => {
  return [
    { [mediaQueries.mobile]: css(styles.mobile) || {} },
    { [mediaQueries.tablet]: css(styles.tablet) || {} },
    { [mediaQueries.desktop]: css(styles.desktop) || {} },
  ];
};

export const visibleOnlyOnMobile = getResponsiveStyles({
  mobile: { display: "inherit", visibility: "visible" },
  tablet: { display: "none", visibility: "hidden" },
  desktop: { display: "none", visibility: "hidden" },
});

export const visibleOnlyOnTablet = getResponsiveStyles({
  mobile: { display: "none", visibility: "hidden" },
  tablet: { display: "inherit", visibility: "visible" },
  desktop: { display: "none", visibility: "hidden" },
});

export const visibleOnlyOnDesktop = getResponsiveStyles({
  mobile: { display: "none", visibility: "hidden" },
  tablet: { display: "none", visibility: "hidden" },
  desktop: { display: "inherit", visibility: "visible" },
});

export const hiddenOnMobile = getResponsiveStyles({
  mobile: { display: "none", visibility: "hidden" },
  tablet: { display: "inherit", visibility: "visible" },
  desktop: { display: "inherit", visibility: "visible" },
});

export const hiddenOnDesktop = getResponsiveStyles({
  mobile: { display: "inherit", visibility: "visible" },
  tablet: { display: "inherit", visibility: "visible" },
  desktop: { display: "none", visibility: "hidden" },
});

/**
 * 🚨🚨🚨 These two helper components should only be used to wrap components
 * that require a `size` prop AND need to be tested. They hide, respectively, mobile-
 * and tablet-only components from the tests, which allows only the desktop-specitic
 * markup to render in the DOM. Once we no longer have external dependencies that
 require `size` props (e.g. ZapTemplate), all usages of these should be removed.
 */

// Hide on anything bigger than mobile
export const VisibleOnlyOnMobile = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) =>
  process.env.NODE_ENV !== "test" ? (
    <div css={visibleOnlyOnMobile}>{children}</div>
  ) : null;

// Hide on mobile and don't render at all for test (test is 1024px wide so "desktop" by default)
export const HiddenOnMobile = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) =>
  process.env.NODE_ENV !== "test" ? (
    <div css={hiddenOnMobile}>{children}</div>
  ) : null;
